import {Suspense, lazy} from 'react';
import {useRoutes, useLocation, Outlet, Navigate} from 'react-router-dom';

import LoadingScreen from '../components/LoadingScreen';

import Private from '../components/authentication/Private';
import Public from '../components/authentication/Public';

import DashboardLayout from '../layouts/dashboard'

import LogoOnlyLayout from '../layouts/LogoOnlyLayout';

const Loadable = (Component) => (props) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const {pathname} = useLocation();

    return (
        <Suspense fallback={<LoadingScreen isDashboard={pathname.includes('/dashboard')}/>}>
            <Component {...props} />
        </Suspense>
    );
};

export default function Router() {
    return useRoutes([
        {
            path: '/login',
            element: <Login/>
        },
        {
            path: '/register',
            element: <Register/>
        },
        {
            path: '/confirm',
            element: <VerifyCode/>
        },
        {
            path: '/reset-password',
            element: <ResetPassword/>
        },
        {
            path: '/new-password',
            element: <NewPassword/>
        },
        {
            path: '/',
            element: <Private><DashboardLayout/></Private>,
            children: [
                {
                    path: '/',
                    index: true,
                    element: <Navigate to="/plugins" replace/>
                },
                {
                    path: '/plugins',
                    element: <MainPage/>,
                },
                {
                    path: '/plugins/:product_id',
                    element: <Outlet/>,
                    children: [
                        {
                            index: true,
                            element: <Plugin/>
                        },
                        {
                            path: '/plugins/:product_id/:license_id',
                            element: <LicenseSingle/>
                        }
                    ]
                },
                {
                    path: '/subscriptions',
                    element: <Outlet/>,
                    children: [
                        {
                            index: true,
                            element: <Subscriptions/>
                        },
                        {
                            path: '/subscriptions/:id',
                            element: <Subscription/>

                        },
                    ]
                },
                {
                    path: '/account',
                    element: <AccountLayout/>,
                    children: [
                        {
                            path: '/account/general',
                            element: <AccountGeneral/>
                        },
                        {
                            path: '/account/security',
                            element: <AccountSecurity/>
                        },
                    ]
                },
                //         {
                //             path: '/products',
                //             element: (
                //                 <ProductsProvider>
                //                     <Outlet/>
                //                 </ProductsProvider>
                //             ),
                //             children: [
                //                 {
                //                     index: true,
                //                     element: <Products/>
                //                 },
                //                 {
                //                     path: '/products/:id',
                //                     element: (
                //                         <ProductLayout/>
                //                     ),
                //                     children: [
                //                         {
                //                             index: true,
                //                             element: <Product/>
                //                         },
                //                     ]
                //                 },
                //             ]
                //         }
            ]
        },
        {
            path: '*',
            element: <LogoOnlyLayout/>,
            children: [
                {path: '*', index: true, element: <Page404/>}
            ]
        }
    ]);
}

// Public Pages
const Login = Public(Loadable(lazy(() => import('../Login'))));
const Register = Public(Loadable(lazy(() => import('../Register'))));
const VerifyCode = Public(Loadable(lazy(() => import('../VerifyCode'))));
const ResetPassword = Public(Loadable(lazy(() => import('../ResetPassword'))));
const NewPassword = Public(Loadable(lazy(() => import('../NewPassword'))));

//Private Pages
const MainPage = Loadable(lazy(() => import('../GeneralApp')))
const Page404 = Loadable(lazy(() => import('../Page404')));
const Plugin = Loadable(lazy(() => import('../Plugin')));
const LicenseSingle = Loadable(lazy(() => import('../LicenseSingle')));
const Subscriptions = Loadable(lazy(() => import('../Subscriptions')));
const Subscription = Loadable(lazy(() => import('../dashboard/subscriptions/subscription/Subscription')));
const AccountLayout = Loadable(lazy(() => import('../dashboard/account/AccountWrapper')));
const AccountGeneral = Loadable(lazy(() => import('../dashboard/account/AccountGeneral')));
const AccountSecurity = Loadable(lazy(() => import('../dashboard/account/AccountSecurity')));
